export default __webpack_public_path__ + "static/media/Custom-HUD-03.a40a246a.jpg";